<template>
  <v-app
    :class="$vuetify.rtl ? `rtl iransans` : `ltr inter`"
    id="inspire"
    :key="applicationHook"
    :style="{
      background:
        $vuetify.theme.themes[$vuetify.theme.dark === true ? 'dark' : 'light']
          .background
    }"
  >
    <transitionPage>
      <router-view />
    </transitionPage>
  </v-app>
</template>

<script>
import transitionPage from "./components/transitionPage/index";
import { mapActions } from "vuex";
import * as types from "@/store/types";
import initService from "@/services/modules/initService";

export default {
  name: "App",
  components: { transitionPage },
  computed: {
    applicationHook() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    // load chatbot
    const userLang = this.$cookies.get("lang");

    // تنظیم پارامترهای داینامیک
    window._curvsAI = window._curvsAI || {};
    window._curvsAI.key = "23419C59CB84ABDEB89B3D8C531DA";
    window._curvsAI.src =
      "https://widget.hooshchat.com/23419C59CB84ABDEB89B3D8C531DA";
    window._curvsAI.customizationParams = {
      lang: userLang,
      welcomeMessage:
        userLang === "fa"
          ? "به پشتیبانی اکسکوینو خوش آمدید؛ چطور می‌تونیم کمکتون کنیم؟"
          : "Welcome to Excoino Support. How can we help you today?",
      formTitle:
        userLang === "fa"
          ? "پشتیبانی آنلاین اکسکوینو"
          : "Excoino Online Support"
    };

    // بارگذاری اسکریپت
    this.loadWidgetScript();

    // this.$vuetify.rtl = true;

    initService.init().then(res => {
      let cookiesLang = res.data.data.language || this.$cookies.get("lang");

      localStorage.setItem("lang", `${cookiesLang}`);
      this.$cookies.set("lang", cookiesLang);
      this.$cookies.set("userChangeSetting", false);

      this.$i18n.locale = cookiesLang;
      if (cookiesLang === "fa" || cookiesLang === "ar") {
        this.$vuetify.rtl = true;
        localStorage.setItem("direction", "rtl");
      } else {
        this.$vuetify.rtl = false;
        localStorage.setItem("direction", "ltr");
      }
    });

    if (localStorage.getItem("isDark")) {
      this.$vuetify.theme.dark = localStorage.getItem("isDark") === "true";
    } else {
      this.$vuetify.theme.dark = true;
    }
  },

  methods: {
    ...mapActions({
      isAuthAction: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    loadWidgetScript() {
      (function(d) {
        var s,
          c,
          o = (window.curvsAI = function() {
            o._.push(arguments);
          });
        o._ = [];
        s = d.getElementsByTagName("script")[0];
        c = d.createElement("script");
        c.type = "text/javascript";
        c.charset = "utf-8";
        c.async = true;
        c.src = "https://widget.hooshchat.com/js/widget.js?";
        s.parentNode.insertBefore(c, s);
      })(document);
    }
  }
};
</script>
